import React, {Fragment} from "react";

// components
import BasicTable from "../../../../Common/Legacy/BasicTable";
import {toMoneyValue, toPercentValue} from "../../../../../utils/reactFunctions";

interface Props {
  detailProps: any;
  featuresAllowed: string[];
}

export default (props: Props) => { 

  // order items
  const tableConfig = (firstColumnName: string) => {
    return [
      {
        headTitle: firstColumnName,
        rowValue: "articleId",
      },
      {
        headTitle: 'ARTÍCULO',
        rowValue: "articleName",
      },
      {
        headTitle: 'BULTOS',
        rowValue: "bundles",
      },
      {
        headTitle: 'UNIDADES ADICIONALES',
        rowValue: "units",
      },
      {
        headTitle: 'BULTOS SIN CARGO',
        rowValue: "noFeeBundles",
      },
      {
        headTitle: 'UNIDADES SIN CARGO',
        rowValue: "noFeeUnits",
      },
      {
        headTitle: 'PRECIO BRUTO',
        rowValue: "totalGrossPrice",
        custom: toMoneyValue
      },
      {
        headTitle: 'BONIFICACIONES',
        rowValue: "totalBonusAndDiscount",
        custom: toPercentValue
      },
      {
        headTitle: 'PRECIO NETO',
        rowValue: "totalNetPrice",
        custom: toMoneyValue
      },
      {
        headTitle: 'IMPUESTOS',
        rowValue: "totalTaxes",
        custom: toMoneyValue
      },
      {
        headTitle: 'PRECIO FINAL',
        rowValue: "totalFinalPrice",
        custom: toMoneyValue
      },
    ];
  };

  return (
    <Fragment>
      <BasicTable
        tableConfig={tableConfig('CÓDIGO ART')}
        tableData={props.detailProps.dataItem.detail}
        parentData= {props.detailProps.dataItem}
        loading={false}
        featuresAllowed={props.featuresAllowed}
      />
    </Fragment>
  );
};
